import React, { useState } from "react";

// import JS files
import PanelTemplate from "../../shares/PanelTemplate";
import BasketBox from "./BasketBox";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";
import TabThree from "./TabThree";

// import Others files

const CreateOrder = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      <PanelTemplate sidebarActiveLink="create-order">
        <>
          <div className="panel-main-header">
            <span>ثبت سفارش محصولات</span>
          </div>
          <BasketBox />
          <div className="mt-12 flex items-center">
            <span
              className={activeTab == "1" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("1")}
            >
              نمایش تمام محصولات
            </span>
            <span
              className={activeTab == "2" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("2")}
            >
              افزودن سریع
            </span>
            <span
              className={activeTab == "3" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("3")}
            >
              خرید های قبلی
            </span>
          </div>
          <div
            style={{ backgroundColor: "#fefcfb" }}
            className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
          >
            {activeTab == "1" ? (
              <TabOne />
            ) : activeTab == "2" ? (
              <TabTwo />
            ) : (
              <TabThree />
            )}
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default CreateOrder;
